import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useIntegration } from 'contexts/integration'
import { accentuate } from '..'
import { Heading, Instructions } from '../s'
import Paragraph from 'components/typography/paragraph'
import { Label } from 'components/form/field/s'
import Copyable from 'components/copyable'
import Actions from 'components/form/actions'
import { Plain } from 'components/button'

const NuuRequiresExternalSetupInformation = ({ name, dismiss }) => {
    const { formatMessage } = useIntl()

    const { integration } = useIntegration()
    const { externalParams = [] } = integration ?? {}

    const id = externalParams?.find(({ name }) => name === 'id')?.value
    const clientId = externalParams?.find(({ name }) => name === 'clientId')?.value
    const clientSecret = externalParams?.find(({ name }) => name === 'clientSecret')?.value

    return (
        <>
            <Heading>
                <FormattedMessage
                    id="integration_heading_connect_to_service"
                    defaultMessage="Connect to {service}"
                    values={{ service: name }} />
            </Heading>
            <Instructions
                className="headings"
                instructions={[
                    {
                        text: formatMessage({
                            id: 'integration_nuu_instruction_add_keys_heading',
                            defaultMessage: 'Add keys to Nuu'
                        }),
                        content: (
                            <>
                                <Paragraph>
                                    <FormattedMessage
                                        id="integration_nuu_instruction_add_keys"
                                        defaultMessage="Find Huma in your Nuu settings and add the <accent>ID</accent>, <accent>Client ID</accent> and <accent>Client secret</accent>."
                                        values={{ accent: accentuate }} />
                                </Paragraph>
                                {!!id && (
                                    <>
                                        <Label className="vertical">
                                            <FormattedMessage
                                                id="integration_label_id"
                                                defaultMessage="ID" />
                                        </Label>
                                        <Copyable
                                            text={id}
                                            className="code" />
                                    </>
                                )}
                                {!!clientId && (
                                    <>
                                        <Label className="vertical">
                                            <FormattedMessage
                                                id="integration_label_clientId"
                                                defaultMessage="Client ID" />
                                        </Label>
                                        <Copyable
                                            text={clientId}
                                            className="code" />
                                    </>
                                )}
                                {!!clientSecret && (
                                    <>
                                        <Label className="vertical">
                                            <FormattedMessage
                                                id="integration_label_clientSecret"
                                                defaultMessage="Client secret" />
                                        </Label>
                                        <Copyable
                                            text={clientSecret}
                                            className="code" />
                                    </>
                                )}
                            </>
                        )
                    },
                    {
                        text: formatMessage({
                            id: 'integration_instruction_save',
                            defaultMessage: 'Click Save'
                        })
                    }
                ]} />
            <Actions className="centered compact">
                <Plain
                    className="neutral"
                    onClick={() => dismiss()}>
                    <FormattedMessage
                        id="action_done"
                        defaultMessage="Done" />
                </Plain>
            </Actions>
        </>
    )
}

export default NuuRequiresExternalSetupInformation